export const RENT_AGREEMENT_SEND = 'rent_agreement:send';
export const NOTIFICATION_TENANT = 'notification:tenant';

// ——————— Whatsapp Related Permission ———————
export const BASIC_WHATSAPP_PERMISSION = 'whatsapp';
export const BAILEY_PERMISSION = 'whatsapp:bailey';